import { Box } from "@mui/material";
import { BulletChart } from 'bizcharts';
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import img from '../../Assets/group-bullet.png';
import DownloadButton from "../Common/DownloadButton";

const GroupBulletChart = (props) => {

    const [data, setData] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                const sorted = results.data.sort((a, b) => { return a['Pesticide'] > b['Pesticide'] ? 1 : -1 });
                if (props.part) {
                    const half = Math.ceil(results.data.length / 2);
                    if (props.part === 1) {
                        setData(sorted.slice(0, half));
                    } else {
                        setData(sorted.slice(-half + 1));
                    }
                } else {
                    setData(sorted);
                }
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    data.map(d => {
        d["Total number of results"] = [parseInt(d["Total number of results"])];
        d["Total number of theoretical results"] = [parseInt(d["Total number of theoretical results"])];
        d["ranges"] = [0, parseInt(d["Total number of theoretical results"]) + parseInt(d["Total number of theoretical results"]) * 0.2]
    })

    return (
        <Box>
            <Box display='flex'>
                <Box sx={{ width: '100%' }}>
                    {!props.second && props.title && <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '1.1rem' }}>{props.title}</p>}
                </Box>
                {!props.first && <Box display='flex' justifyContet='flex-end'>
                    <DownloadButton fileName={props.title} csv={data} imageAsset={img} />
                </Box>
                }

            </Box>
            {data.map((d, idx) => {
                d = [d];
                return (
                    <Box key={idx} pb={1}>
                        <Box sx={{ width: '100%', fontSize: '12px', fontFamily: 'Roboto Condensed, sans-serif', textAlign: 'center' }}>
                            {d[0]['Pesticide']}
                        </Box>
                        <BulletChart
                            autoFit
                            data={d}
                            height={50}
                            measureField="Total number of results"
                            targetField='Total number of theoretical results'
                            xField=''
                            rangeSize={20}
                            yAxis={{
                                position: 'left',
                                tickCount: 6,
                                max: d[0]["Total number of theoretical results"]
                            }}
                            measureSize={10}
                            rangeColors={['#ccc']}
                            measureColors={['#246898']}
                            markerColors={['#246898']}
                            label={false}
                            tooltip={{
                                title: d[0]['Pesticide'],
                                shared: true,
                            }}
                        />
                    </Box>
                )
            })}

        </Box>
    );
}

export default GroupBulletChart;